import { Form, message, Radio, Tabs, TabsProps } from 'antd'
import {
  SActionBtn,
  SDrawerOrModal,
  SGeneralForms,
  SLowcodeList,
  SSegmentedTabs,
  STableActions,
} from 'shj-components'
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import _, { isArray } from 'lodash'
import { useUpdateEffect } from 'ahooks'
import { useParams } from 'react-router-dom'
import { getOrCacheProductRuleDtl, getProductEnums, packModelSkuDetail } from '@/services/product'
import { useStore, useAtomValue, useAtom, useSetAtom } from 'jotai'
import { step1DataAtom, step2DataAtom } from '../store'

export default forwardRef(function Step3(props: any, ref) {
  const { current } = props
  const [config, setConfig] = useState({
    rowSelection: true,
    columns: [
      {
        title: '采购价（元）',
        dataIndex: 'buyPrice',
      },
      {
        title: '销售指导价生成',
        dataIndex: 'saleTypeName',
      },
      {
        title: '毛利（%）',
        dataIndex: 'gpAmount',
      },
      {
        title: '销售指导价（元）',
        dataIndex: 'salePrice',
      },
      {
        title: '操作',
        dataIndex: 'actions',
        width: 128,
        render: 'actionRender',
        fixed: 'right',
      },
    ],
    search: [],
    footer: [
      {
        label: '批量编辑',
        type: 'primary',
        events: ['onClick:onBatchEdit'],
      },
    ],
    batchActions: [],
  })
  const { id } = useParams() // 产品id
  const [data, setData] = useState<any>([])
  const listRef = useRef<any>()
  const formRef = useRef()
  const [saleTypeList, setSaleTypeList] = useState<any>([])
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])
  const [record, setRecord] = useState<any>({})
  const [open, setOpen] = useState(false)
  const [editMode, setEditMode] = useState('single')

  const step1Data = useAtomValue(step1DataAtom)
  const step2Data = useAtomValue(step2DataAtom)

  // 动态添加表格  获取缓存初始化
  useEffect(() => {
    console.log(step2Data, '数据变更')
    if (step2Data?.['skuList']) {
      let newConfig: any = {
        rowSelection: true,
        columns: [
          {
            title: '销售指导价生成',
            dataIndex: 'saleTypeName',
          },
          {
            title: '毛利（%）',
            dataIndex: 'gpAmount',
          },
          {
            title: '销售指导价（元）',
            dataIndex: 'salePrice',
          },
          {
            title: '操作',
            dataIndex: 'actions',
            width: 128,
            render: 'actionRender',
            fixed: 'right',
          },
        ],
        search: [],
        footer: [
          {
            label: '批量编辑',
            type: 'primary',
            events: ['onClick:onBatchEdit'],
          },
        ],
        batchActions: [],
      }
      if (step1Data.prodType !== 'PRODUCT_GROUP' && !(id && step1Data.sourceType !== 'SELF')) {
        newConfig.columns.unshift({
          title: '采购价（元）',
          dataIndex: 'buyPrice',
        })
      }
      let newData: Array<any> = []
      newData = step2Data.skuList
      let array = isArray(step2Data.skuTableColumns.concat(newConfig.columns))
        ? step2Data.skuTableColumns.concat(newConfig.columns)
        : []
      newConfig.columns = [
        {
          title: 'SKU编码',
          dataIndex: 'id',
        },
        ...array,
      ]
      setConfig({ ...newConfig })
      setData([...newData])
    }
  }, [step2Data.skuList])

  const onBatchEdit = record => {
    if (selectedRowKeys && selectedRowKeys.length === 0) {
      message.error('请选择需要批量编辑的数据')
      return
    }
    setEditMode('batchEdit')
    onFormRef()?.resetFields()
    setOpen(true)
  }
  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }
  useEffect(() => {
    if (open && editMode == 'batchEdit') {
      onFormRef?.()?.setFieldsValue({
        saleType: saleTypeList[0].value,
      })
    }
  }, [open])
  const onEdit = (record = {}, type) => {
    onFormRef()?.resetFields()
    setOpen(true)
    if (type === 'singleEdit') {
      setEditMode('singleEdit')
      setRecord(record)
      onFormRef?.()?.setFieldsValue({
        ...record,
        saleType: record.saleType ? record.saleType : saleTypeList[0].value,
      })
    }
  }
  // 表单提交
  const onSubmit = () => {
    onFormRef?.()
      ?.validateFields()
      .then(values => {
        values.saleTypeName = saleTypeList.find(item => item.value === values.saleType)?.label
        let newData: any = [...data]
        if (values.saleType === 'COST') {
          values.salePrice = ''
        } else if (values.saleType === 'DEFINE') {
          values.gpAmount = ''
        }
        newData = newData.map((item: any) => {
          if (selectedRowKeys && selectedRowKeys.includes(item.id) && editMode == 'batchEdit') {
            item = { ...item, ...values }
          } else if (record && item.id === record.id) {
            item = { ...item, ...values }
          }
          return item
        })
        setData([...newData])
        setOpen(false)
        setRecord(null)
      })
  }
  useUpdateEffect(() => {
    listRef.current?.updateDataSource(data, data.length)
    // listRef.current?.reload()
  }, [data])

  // 保存当前数据
  useImperativeHandle(
    ref,
    () => {
      return {
        data,
        setData,
      }
    },
    [data]
  )
  const getOptions = async () => {
    return new Promise(resolve => {
      getProductEnums('com.shj.saas.plus.product.enums.SalePriceTypeEnum').then((res: any) => {
        res = res.map((item: any) => {
          return {
            label: item.description,
            value: item.key,
          }
        })
        setSaleTypeList(res)
      })
    })
  }
  const extensions = {
    request: {},
    events: {
      onBatchEdit,
    },
    status: {},
    selectedRowKeys: selectedRowKeys,
    onSelectedRowChange: (keys, rows) => {
      setSelectedRowKeys(keys)
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record, 'singleEdit')}>编辑</SActionBtn>
          </STableActions>
        )
      },
    },
  }
  return (
    <div>
      {/* <Tabs onChange={onChange} type="card" items={items} /> */}
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      <SDrawerOrModal
        title="编辑"
        mode="modal"
        open={open}
        onCancel={() => {
          setOpen(false)
        }}
        onOk={onSubmit}
        width={500}
      >
        <SGeneralForms
          ref={formRef}
          httpOptionsFn={getOptions}
          layout={'vertical'}
          initialValues={{}}
          configs={[
            {
              formItem: [
                {
                  label: '采购价（元）',
                  name: 'buyPrice',
                  spanCol: 24,
                  type: 'inputNumber',
                  required: true,
                  isDeps: true,
                  deps: form =>
                    step1Data.prodType !== 'PRODUCT_GROUP' &&
                    !(id && step1Data.sourceType !== 'SELF'),
                },
                {
                  label: '销售指导价生成',
                  name: 'saleType',
                  spanCol: 24,
                  required: true,
                  children: (text: any, record: any) => {
                    return (
                      <Radio.Group
                        options={saleTypeList}
                        style={{ padding: 0 }}
                        onChange={(e: any) => {
                          onFormRef().setFieldsValue({
                            saleType: e?.target?.value,
                          })
                        }}
                      />
                    )
                  },
                },
                {
                  label: '毛利（%）',
                  name: 'gpAmount',
                  isDeps: true,
                  deps: form => form.getFieldValue('saleType') === 'COST',
                  spanCol: 24,
                  type: 'inputNumber',
                  comConfig: { min: 0, max: 99.99 },
                },
                {
                  label: '销售指导价（元）',
                  isDeps: true,
                  deps: form => form.getFieldValue('saleType') === 'DEFINE',
                  name: 'salePrice',
                  spanCol: 24,
                  type: 'inputNumber',
                },
              ],
            },
          ]}
        />
      </SDrawerOrModal>
    </div>
  )
})
